<h2 class="self-center text-h2 font-semibold">{{ 'collab_link_patient_chart_modal_title' | translate }}</h2>
@if (!isShowcase()) {
  <form [formGroup]="form" class="flex flex-col gap-4 rounded-3xl bg-background-white/60 p-6 backdrop-blur">
    <lib-search-participants
      [options]="patients()"
      [label]="'collab_new_collab_modal_collaboration_participant_patient_label' | translate"
      [placeholder]="'collab_new_collab_modal_collaboration_participant_patient_placeholder' | translate"
      [hint]="'collab_link_patient_chart_modal_select_patient_hint' | translate"
      [noResultLabel]="'collab_new_collab_modal_collaboration_no_result_label' | translate"
      [prefixIcon]="'px-24-dentist'"
      [loading]="patientsLoading()"
      [closeOnSelect]="true"
      (searchTerm)="onSearchPatients($event)"
      (itemSelected)="onAddPatientParticipant($event)"
      (endReached)="onPatientsEndReached()"
      [isPatientSearch]="true"
    />

    @if (patientParticipant(); as patient) {
      <lib-selected-participant [participant]="patient" (removeParticipant)="onRemovePatientParticipant()" />
    }
  </form>
} @else {
  <p class="my-4 text-h7 font-light text-text-tertiary">{{ 'collab_link_patient_showcase_description' | translate }}</p>
  <div class="flex flex-col gap-4 rounded-3xl bg-background-white/60 p-6 backdrop-blur">
    @for (patient of allPatients(); track $index) {
      <div (click)="onAddPatientParticipant(patient)" class="flex cursor-pointer items-center justify-between">
        <div class="flex items-center gap-3">
          <lib-avatars class="inline-flex" [persons]="[patient]" [size]="32"></lib-avatars>
          <div>{{ patient.firstName }} {{ patient.lastName }}</div>
        </div>
        @if (patient.id === selectedPatient()?.id) {
          <div class="flex h-[24px] w-[24px] items-center rounded-full bg-secondary-green bg-opacity-20">
            <svg-icon key="px-24-tick" class="text-secondary-green transition" />
          </div>
        }
      </div>
    }
  </div>
}
<div class="flex gap-10 self-end">
  <button class="btn-text" (click)="closeDialog()">{{ 'collab_link_patient_chart_modal_cancel' | translate }}</button>
  <button class="btn-primary" (click)="saveLinkedPatient()">{{ 'collab_link_patient_chart_modal_save' | translate }}</button>
</div>
